import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';

class NotFound extends Component {
    render() {
    	return(
    		<div className="singlePatient">
    			<div className="blockCtr patients br10 sh1">
	    			<div className="blockHeader br10Top">
	    				<Link to="/" className="backBtn br10TopLeft"><span className="fas fa-chevron-left"></span></Link>
	    				<h3><strong>Error 404</strong> - Not Found</h3>
	    			</div>
	    			<div className="blockInfo">
	    				Oops! The page you are looking for doesn't exist. Please, go to the dashboard and try again.
	    			</div>
	    		</div>
    		</div>
    	);
    }
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/components/NotFound.js